import { useCallback } from 'react';
import {
  getDefaultFetchBondsPayload,
  getDefaultFetchLoansPayload,
} from '../../pages/Company/CompanyDocumentsTab/CompanyDocumentsTab.logic';
import useFetchBonds from './useFetchBonds';
import useFetchCompanyDocs from './useFetchFilings';
import useFetchLoans from './useFetchLoans';

type HookReturnValue = {
  bondsTotalResults: number;
  isError: boolean;
  isLoading: boolean;
  loansTotalResults: number;
  filingsTotalResults: number;
  refetch: () => Promise<void>;
};

export default (issuerId: string): HookReturnValue => {
  const {
    data: bondsDocuments,
    isError: bondsError,
    refetch: fetchBonds,
    isLoading: bondsLoading,
  } = useFetchBonds(issuerId, getDefaultFetchBondsPayload(issuerId, 1));

  const {
    data: loansDocuments,
    isError: loansError,
    refetch: fetchLoans,
    isLoading: loansLoading,
  } = useFetchLoans(issuerId, getDefaultFetchLoansPayload(issuerId, 1));

  const {
    data: filingsDocuments,
    isError: filingsError,
    refetch: fetchFilings,
    isLoading: filingsLoading,
  } = useFetchCompanyDocs(issuerId, { skip: 0, take: 1, source: ['lfi', 'cms'], sortDesc: false });

  const refetch = useCallback(async () => {
    await (bondsError && fetchBonds());
    await (loansError && fetchLoans());
    await (filingsError && fetchFilings());
  }, [loansError, bondsError, filingsError, fetchBonds, fetchLoans, fetchFilings]);

  const bondsTotalResults = bondsDocuments?.totalResults || 0;
  const loansTotalResults = loansDocuments?.totalResults || 0;
  const filingsTotalResults = filingsDocuments?.totalResults || 0;

  return {
    bondsTotalResults,
    isError: bondsError || loansError || filingsError,
    isLoading: bondsLoading || loansLoading || filingsLoading,
    loansTotalResults,
    filingsTotalResults,
    refetch,
  };
};
